import { ViewMode } from './urlState';

/**
 * The four browse modes shown in the mode switcher. Keep order stable —
 * the URL `?view=` param uses these keys.
 */
export interface ModeMeta {
  readonly key: ViewMode;
  readonly label: string;
  readonly icon: string; // Material Symbols Rounded ligature
  readonly desc: string;
}

export const MODES: readonly ModeMeta[] = [
  { key: 'levels', label: 'За рівнями', icon: 'stairs', desc: 'Від A1 до C2' },
  { key: 'forms', label: 'За формами', icon: 'view_column', desc: 'AAA · ABB · ABA · ABC' },
  { key: 'patterns', label: 'За патернами', icon: 'category', desc: 'Групи за типом зміни форм' },
  { key: 'families', label: 'За сімействами', icon: 'account_tree', desc: 'Базові дієслова та похідні' },
];
